export default {"src":"/_next/static/media/suggest-bottle.053506d6.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};